"use client";
import { GeoFenceContextProvider } from "./context/dropContext";
import { Suspense } from "react";
import LoadingScreen from "@/components/UI/loading-screen";

export default function DropNFTLayout({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) {
	return (
		<Suspense fallback={<LoadingScreen />}>
			<GeoFenceContextProvider>
				<div className="bg-mgt-black min-h-full pb-5">{children}</div>
			</GeoFenceContextProvider>
		</Suspense>
	);
}
